/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warehouse_Defects_Table_TitleInputs */

const vi_warehouse_defects_table_title = /** @type {(inputs: Warehouse_Defects_Table_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi tiết hàng lỗi theo kỳ × sản phẩm`)
};

/**

* @param {Warehouse_Defects_Table_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const warehouse_defects_table_title = /** @type {((inputs?: Warehouse_Defects_Table_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warehouse_Defects_Table_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_warehouse_defects_table_title(inputs)
});